import { render, staticRenderFns } from "./YourAlerts.vue?vue&type=template&id=699bf3e9"
import script from "./YourAlerts.vue?vue&type=script&lang=js"
export * from "./YourAlerts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports